import CloseIcon from 'public/images/icons/close.svg';
import { FunctionComponent, ReactNode } from 'react';
import { Button } from 'src/shared-components';
import Title from 'src/shared-components/Modal/Title';

interface CarouselProps extends React.HTMLAttributes<HTMLDivElement> {
  currentStep: number;
  children: ReactNode;
  steps: Array<{ position: number; title: string; subtitle?: string; action?: string; hideStep?: boolean }>;
  onButtonClick?: () => void;
  stepsLength?: number;
  buttonColor?: 'primary' | 'secondary' | 'black' | 'gray' | 'white' | 'light-blue' | 'dark';
  closeButton?: boolean;
  closeFunction?: () => void;
  titleClassName?: string;
  textCenterTitle?: boolean;
  stepTextCenter?: boolean;
  subtitleClass?: string;
  buttonSize?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  buttonClass?: string;
  backButton?: boolean;
  onBackClick?: () => void;
}

const Carousel: FunctionComponent<CarouselProps> = ({
  children,
  currentStep,
  steps,
  onButtonClick,
  stepsLength,
  buttonColor = 'primary',
  closeButton = false,
  closeFunction,
  titleClassName,
  textCenterTitle = true,
  stepTextCenter = true,
  subtitleClass,
  buttonSize = 'lg',
  buttonClass,
  backButton = false,
  onBackClick,
  ...rest
}: CarouselProps) => {
  const hideStep = steps[currentStep].hideStep;
  return (
    <div className={rest.className}>
      <div
        className={`uppercase relative ${stepTextCenter ? 'text-center' : 'text-left'} font-bold ${
          hideStep ? null : 'pb-4 border-solid border-b'
        }`}
      >
        {hideStep ? null : (
          <span className="inline-block w-full">{`step ${currentStep + 1} of ${stepsLength || steps.length}`}</span>
        )}
        {closeButton ? (
          <CloseIcon
            data-testid="close-icon"
            fill="#595959"
            onClick={closeFunction}
            className="inline cursor-pointer absolute right-1 top-1"
          />
        ) : null}
      </div>
      <div className="text-center mt-4">
        <Title
          title={steps[currentStep].title}
          subtitle={steps[currentStep].subtitle}
          className={titleClassName}
          center={textCenterTitle}
          subtitleClass={subtitleClass}
        />
        {children}
      </div>
      {steps[currentStep].action && (
        <div className="flex mt-6">
          {backButton && currentStep !== 0 && (
            <Button
              className={`bg-[#F0F0F0] text-black border-0 mr-5 basis-1/4`}
              size={buttonSize}
              roundness="md"
              color={buttonColor}
              fullWidth
              onClick={onBackClick}
            >
              Back
            </Button>
          )}
          <Button
            className={`${buttonClass} ${backButton && currentStep !== 0 && 'basis-3/4'}`}
            size={buttonSize}
            roundness="md"
            color={buttonColor}
            fullWidth
            onClick={onButtonClick}
          >
            {steps[currentStep].action}
          </Button>
        </div>
      )}
    </div>
  );
};

export default Carousel;
